<div class="main-container">
  @if (pay) {
  <div class="approve-container">
    <mat-icon svgIcon="ic-check-on"></mat-icon>
    @if (pay === 'true') {
    <p class="as-font as-font-24">{{ 'PAYPAL.completed' | translate }}</p>
    } @if (pay === 'false') {
    <p class="as-font as-font-24">{{ 'PAYPAL.completedMethod' | translate }}</p>
    }
  </div>
  } @if (message) {
  <div class="approve-container">
    <mat-icon svgIcon="ic-tooltip-error"></mat-icon>
    <p class="as-font as-font-24">{{ message }}</p>
  </div>
  }
</div>
